import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import WhatsAppButton from '../../components/ui/WhatsAppButton';
import HeroSection from './components/HeroSection';
import MetricsSection from './components/MetricsSection';
import StrategicDomainsSection from './components/StrategicDomainsSection';
import InterventionDomainsSection from './components/InterventionDomainsSection';
import OfficialCTASection from './components/OfficialCTASection';
import TestimonialsSection from './components/TestimonialsSection';
import SatisfiedClientsSection from './components/SatisfiedClientsSection';


const Homepage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />
      {/* Main Content */}
      <main className="pt-16">
        <HeroSection />
        <MetricsSection />
        <StrategicDomainsSection />
        <InterventionDomainsSection />
        <OfficialCTASection />
        <TestimonialsSection />
        <SatisfiedClientsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Homepage;